import { render, staticRenderFns } from "./workmaster-index.vue?vue&type=template&id=2d64f5b8&scoped=true"
import script from "./workmaster-index.vue?vue&type=script&lang=js"
export * from "./workmaster-index.vue?vue&type=script&lang=js"
import style0 from "./workmaster-index.vue?vue&type=style&index=0&id=2d64f5b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d64f5b8",
  null
  
)

export default component.exports